import styled from 'styled-components';
import {context} from '../stepContext/StepContext.css';
import {wrapper as wRight} from '../stepRight/StepRight.css';
import {wrapper as wLeft} from '../StepLeft/StepLeft.css';
import {LIGHT_GRAY_BG} from '../../../../globalVariables/GlobalVariables';

export const wrapAll=styled.div`
${context}{
    display:block;
}
${wRight}{
    width:100%;
}
${wLeft}{
    width:100%;
    margin-top:5px;
}
`;

export const Textarea=styled.div`
    margin-top: 10px;
    border-radius: 20px 20px 0 0;
    background: ${LIGHT_GRAY_BG};
    position: relative;
    .quill{
        min-height: 250px;
    }
    .ql-editor{
        min-height: 250px;
    }
`;